module.exports = __webpack_public_path__ + "static/img/no-routine-01.1f8900c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/no-routine-01.jpg
// module id = 278
// module chunks = 1